import styled from 'styled-components';

export const StyledGroupActionButton = styled.div`
    display: flex;
    gap: 1rem;
`;
